import AutoInvoiceCrud from "../components/auto-invoice/AutoInvoiceCrud";

const AutoInvoicesPage = () => {
  return <AutoInvoiceCrud />;
};

export default AutoInvoicesPage;
